// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3r9po","inner":"Form_inner__1M4Yb","range":"Form_range__4Rb7O","name":"Form_name__sa8yX","actions":"Form_actions__2Stw3"};